var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 25.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".download_svg__st0{fill:#3d5560}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__st0",
    d: "M4820.8 994.6c-.1-.8.5-1.5 1.3-1.6s1.5.5 1.6 1.3v11.8l4.7-5.2 2.1 2.3-8.2 9.1-8.2-9.1 2.1-2.3 4.7 5.2v-11.5z",
    transform: "translate(-4810.243 -993.003)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__st0",
    d: "M4810.2 1009.1h3v6.4h18v-6.4h3v6.4c.1 1.7-1.3 3.2-3 3.2h-18c-1.7-.1-3.1-1.5-3-3.2v-6.4z",
    transform: "translate(-4810.243 -993.003)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4f7314fe.svg";
export { ForwardRef as ReactComponent };